import React, { Component } from "react";
import { Row, Col, Card, CardBody, CardTitle } from "reactstrap";
import { Link } from "react-router-dom";

class SocialSource extends Component {
  constructor(props) {
    super(props);
    this.state = {
      socials: [
        {
          title: "Suppliers",
          bgColor: "bg-primary",
          iconClass: "mdi-account-multiple-outline",
          description: "125",
        },
        {
          title: "Venues",
          bgColor: "bg-info",
          iconClass: "mdi-account-multiple",
          description: "112",
        },
        {
          title: "Promoters",
          bgColor: "bg-pink",
          iconClass: "mdi-account",
          description: "104",
        },
      ],
    };
  }

  render() {
    return (
      <React.Fragment>
        <Card>
          <CardBody>
            <CardTitle className="mb-4 h4">Users Statistics</CardTitle>
            <div className="text-center">
              <div className="avatar-sm mx-auto mb-4">
                <span className="avatar-title rounded-circle bg-primary bg-soft font-size-24">
                  <i className="mdi mdi-account-group text-primary" />
                </span>
              </div>
              <p className="font-16 text-muted mb-2" />
              <h5>Clients</h5>
              <p className="text-muted mb-0">125</p>
              <p className="text-muted">
                Maecenas nec odio et ante tincidunt tempus. Donec vitae sapien
              </p>
              <Link to="#" className="text-primary font-16">
                Learn more <i className="mdi mdi-chevron-right" />
              </Link>
            </div>
            <Row className="mt-4">
              {this.state.socials.map((social, key) => (
                <Col xs="4" key={"_li_" + key}>
                  <div className="social-source text-center mt-3">
                    <div className="avatar-xs mx-auto mb-3">
                      <span
                        className={
                          "avatar-title rounded-circle " +
                          social.bgColor +
                          " font-size-16"
                        }
                      >
                        <i
                          className={"mdi " + social.iconClass + " text-white"}
                        />
                      </span>
                    </div>
                    <h5 className="font-size-15">{social.title}</h5>
                    <p className="text-muted mb-0">
                      {social.description} sales
                    </p>
                  </div>
                </Col>
              ))}
            </Row>
          </CardBody>
        </Card>
      </React.Fragment>
    );
  }
}

export default SocialSource;
